import { BaseProps } from '@/components/types'
import { Icon, Card, Grid, Skeleton, CardMedia, useMediaQuery } from '@/components'
import { CSSProperties, useState, MouseEvent } from 'react'
import { NumberUtil } from '@/util'
import { REVIEW_LIST } from '@/constants/prop/ItemProcess'

function ItemPreview ( props: ItemPreviewProps ) {
    const {
        imageWidth = '620px', imageHeight = '250px',
        data, marginTop, marginBottom,
        onClickImage,
        ...rest
    } = props
    const { imageSrc, itemProcess, propertyNo, propertyName, advisorId, itemAddr, loanAmount } = data
    const [ isLoading, setIsLoading ] = useState( true )
    const matches = useMediaQuery( '( max-width: 1280px )' )
    const imageWrapperStyle: CSSProperties = {
        boxSizing: 'border-box',
        height: imageHeight,
        width: imageWidth,
        textAlign: 'center',
        backgroundColor: 'rgba(242, 242, 242)',
        borderRadius: '12px',
        margin: '20px auto',
    }
    const imageStyle: CSSProperties = isLoading ? {
        display: 'none'
    } : {
        height: '100%',
        objectFit: 'fill',
        borderRadius: '12px',
        cursor: 'pointer'
    }
    const getItemColorByProcess = ( itemProcess: string ): string => {
        let backgroundColor = ''

        switch ( itemProcess ) {
            case 'REQUEST':
                backgroundColor = '#5A6271'
                break
            case 'UNDER':
                backgroundColor = '#5891FF'
                break
            case 'COMPLETE':
                break
        }

        return backgroundColor
    }
    const onCustomClick = ( e: MouseEvent<HTMLDivElement> ) => {
        onClickImage && onClickImage( data )
    }

    return (
        <Card sx={ { marginTop, marginBottom, padding: '8px', width: `${ matches ? 100 : 48 }%` } }>
            <div
                { ...rest }
                className="item-preview-image-wrapper w100p"
                style={ imageWrapperStyle }
                onClick={ onCustomClick }
            >
                {
                    isLoading && (
                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height="100%"
                        >
                            <div style={{ paddingTop: '50%' }} />
                        </Skeleton>
                    )
                }
                {
                    <CardMedia
                        sx={ { ...imageStyle } }
                        component="img"
                        image={ imageSrc || randomImage( ( Math.floor( Math.random() * 5 ) + 1 ) )}
                        onLoad={ () => { setIsLoading( false ) } }
                    />
                }
            </div>
            <Grid
                container
                rowSpacing={ 1 }
                columnSpacing={ { xs: 1, sm: 2, md: 1 } }
                sx={ { m: 1, textAlign: 'center' } }
                justifyContent="space-between"
                alignItems="flex-start"
            >
                <Grid item xs={ 2 }>
                    <PaperText style={ { background: getItemColorByProcess( itemProcess ) } }>{ REVIEW_LIST.find( ( { value } ) => value === itemProcess )?.name || itemProcess }</PaperText>
                </Grid>
                <Grid item xs={ 3 }>
                    <PaperText icon="place">{ itemAddr }</PaperText>
                </Grid>
                <Grid item xs={ 5 }>
                    <PaperText className={ propertyNo } icon="domain">{ propertyName }</PaperText>
                </Grid>
                <Grid item xs={ 2 }>
                    <PaperText className={ advisorId } icon="money">{ loanAmount ? NumberUtil.formatNumber( loanAmount ) : 0 }</PaperText>
                </Grid>
            </Grid>
        </Card>
    )
}

function PaperText ( props: PaperTextProps ): JSX.Element {
    const { style, className, icon, children } = props
    const textStyle: CSSProperties = {
        width : '100%',
        height: '20px',
        padding: '10px 0',
        overflow: 'hidden',
        outline: 'none',
        borderRadius: '5px',
        border: '1.5px solid #D9E2ED',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color: style?.background ? '#fff' : 'black',
        ...style,
    }

    return <div style={ textStyle } className={ className }>
        { icon && <Icon fontSize="inherit" style={ { height: '14px', marginRight: '4px' } }>{ icon }</Icon> }
        { children }
    </div>
}

export default ItemPreview

export type ItemData = {
    propertyId: number,
    imageSrc?: string,
    itemProcess?: string
    propertyNo?: string
    propertyName?: string
    itemAddr?: string
    advisorId?: string
    loanAmount?: number
}
export interface IItemPreview {
    imageWidth?: string,
    imageHeight?: string,
    data: ItemData
}
export interface ItemPreviewProps extends IItemPreview, BaseProps {
    marginTop?: string | number
    marginBottom?: string | number
    onClickImage?: ( data: ItemData ) => void
}

export interface PaperTextProps extends BaseProps {
    icon?: string
}

const randomImage = ( seq: number ) => require( `@/assets/img/invest${seq}.jpeg`)